module.exports = __webpack_public_path__ + "img/sys-config_w.aff57abc.svg";